"use client";

import { ReactNode, useState, useEffect } from "react";
import CookieConsent from "react-cookie-consent";
import { useTranslations } from "next-intl";
import TransitionProvider from "@/app/components/TransitionProvider";
import HolidayNoticeModal from "./HolidayNoticeModal";
import { Link } from "@/i18n/routing";

// export default function Providers({ children }: { children: ReactNode }) {
//   return <TransitionProvider>{children}</TransitionProvider>;
// }

export default function Providers({ children }: { children: ReactNode }) {
  const t = useTranslations("common");
  const [hasConsent, setHasConsent] = useState(true);

  useEffect(() => {
    // Check if consent exists
    const cookieConsent = document.cookie
      .split(";")
      .some((item) => item.trim().startsWith("aries-cookie-consent=true"));
    setHasConsent(cookieConsent);
  }, []);

  const handleAccept = () => {
    setHasConsent(true);

    // Set the consent cookie with a longer expiration (150 days = ~5 months)
    document.cookie =
      "aries-cookie-consent=true; max-age=12960000; path=/; SameSite=Lax";

    // Initialize analytics or other cookie-dependent services here
    if (typeof window !== "undefined") {
      // Example: Initialize Google Analytics (if you add it in the future)
      // if (window.gtag) {
      //   window.gtag('consent', 'update', {
      //     'analytics_storage': 'granted'
      //   });
      // }

      console.log("Cookies accepted - Analytics enabled");
    }
  };

  const handleDecline = () => {
    setHasConsent(false);

    // Remove the consent cookie
    document.cookie =
      "aries-cookie-consent=false; max-age=12960000; path=/; SameSite=Lax";

    // Remove analytics or non-essential cookies here
    if (typeof window !== "undefined") {
      // Example: Disable Google Analytics cookies (if you add it in the future)
      // if (window.gtag) {
      //   window.gtag('consent', 'update', {
      //     'analytics_storage': 'denied'
      //   });
      // }

      // Optional: Clear any existing analytics cookies
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name =
          eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

        // Delete any Google Analytics cookies (if you use them in the future)
        if (
          name.startsWith("_ga") ||
          name.startsWith("_gid") ||
          name.startsWith("_gat")
        ) {
          document.cookie =
            name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
      }

      console.log("Cookies declined - Analytics disabled");
    }
  };

  return (
    <>
      {children}
      <HolidayNoticeModal />
      <CookieConsent
        location="bottom"
        buttonText={t("cookie.accept")}
        declineButtonText={t("cookie.reject")}
        enableDeclineButton
        onAccept={handleAccept}
        onDecline={handleDecline}
        cookieName="aries-cookie-consent"
        containerClasses="!bg-white dark:!bg-gray-800 !shadow-lg !p-4 !border-t !border-gray-200 dark:!border-gray-700"
        contentClasses="!flex !items-center !flex-wrap !justify-center !gap-3 !text-gray-700 dark:!text-gray-300 !text-sm !my-0"
        buttonWrapperClasses="!inline-flex !gap-2 !ml-2"
        buttonClasses="!bg-blue-600 hover:!bg-blue-700 !text-white !font-medium !text-sm !rounded-md !px-3 !py-1 !transition-colors !duration-200 !m-0"
        declineButtonClasses="!bg-gray-200 hover:!bg-gray-300 dark:!bg-gray-600 dark:hover:!bg-gray-500 !text-gray-700 dark:!text-gray-200 !font-medium !text-sm !rounded-md !px-3 !py-1 !transition-colors !duration-200 !m-0"
        expires={150}
        disableButtonStyles={true}>
        <div className="flex flex-wrap items-center justify-center gap-2">
          {t("cookie.message")}
          <Link
            href="/privacy"
            className="text-sm text-blue-600 hover:underline">
            {t("cookie.learnMore")}
          </Link>
        </div>
      </CookieConsent>
    </>
  );
}
